export default __webpack_public_path__ + "static/media/Aqum.41b007e6.ttf";